import axios from "axios";
import qs from "qs";

axios.defaults.timeout = 30000;
axios.defaults.baseURL = process.env.BASE_API;

//http response 拦截器ss
axios.interceptors.response.use(
  response => {
    let config = response.config
    if(config.url.includes('/wx/route')){
      return response;
    }
    if (
      response.data.result == "failed" &&
      response.data.message == "当前用户登录已失效！"
    ) {
      let isWeiXin = () => {
        return (
          navigator.userAgent.toLowerCase().indexOf("micromessenger") !== -1
        );
      };
      let logincode = sessionStorage.logincode;
      let weblogincode = sessionStorage.weblogincode;
      
      sessionStorage.logincode = "0";
      if (isWeiXin()) {
        sessionStorage.logincode = "1";
        let url =
          "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
          process.env.BASE_appid +
          "&redirect_uri=" +
          process.env.BASE_url +
          "/login&response_type=code&scope=snsapi_base&state=weixin#wechat_redirect";
          window.location.replace(url);
      } else {
        if (weblogincode == "1") {
          return;
        } else {
          sessionStorage.weblogincode = "1";
          let urls = process.env.BASE_url + "/login";
          window.location.replace(urls);
        }
      }
    }
    return response;
  },
  error => {
    return Promise.reject(error);
  }
);

/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */

export function fetch(url, params = {}) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params: params
      })
      .then(response => {
        resolve(response.data);
      })
      .catch(err => {
        reject(err);
      });
  });
}

/**
 * 封装post请求表单类型
 * @param url
 * @param data
 * @returns {Promise}
 */
export function post(url, data) {
  return new Promise((resolve, reject) => {
    axios({
      url: url,
      method: "post",
      data: qs.stringify(data),
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      }
    })
      .then(res => {
        resolve(res);
      })
      .catch(error => {
        reject(error);
      });
  });
}

/**
 * 封装post请求josn类型
 * @param url
 * @param data
 * @returns {Promise}
 */
export function posts(url, data) {
  return new Promise((resolve, reject) => {
    axios({
      url: url,
      method: "post",
      data: data,
      headers: {
        "Content-Type": "application/json"
      }
    })
      .then(res => {
        resolve(res);
      })
      .catch(error => {
        reject(error);
      });
  });
}
/**
 * 封装patch请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function patch(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.patch(url, data).then(
      response => {
        resolve(response.data);
      },
      err => {
        reject(err);
      }
    );
  });
}

/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */

export function put(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.put(url, data).then(
      response => {
        resolve(response.data);
      },
      err => {
        reject(err);
      }
    );
  });
}



// WEBPACK FOOTER //
// ./src/utils/http.js